/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled,  { css } from 'styled-components';
import Colors from 'constants/Colors';
import { mediaHelperMaxWidth } from "../../utils/src";
import { Breakpoints } from 'constants/Breakpoints';
import { FontWeight } from 'components/Text';

export const Dialog = styled.div`
  position: fixed; 
  z-index: 5; 
  padding-top: 5vh;
  left: 0;
  top: 0;
  width: 100%; 
  height: 100%; 
  overflow: hidden; 
  background-color: rgba(255,255,255,0.4);
  backdrop-filter: blur(1px);

  ${({ canShow }) =>
  canShow
    ? css`
        display: block;
        `
    : `display: none;`
}

@media screen and (min-width: ${Breakpoints.sm}) {
    padding-top: 5vh;
}

  @media screen and (min-width: ${Breakpoints.xl}) {
    padding-top: 15vh;
  }


  ${mediaHelperMaxWidth.md`
    padding-top: 2vh;
  `}
`;

export const DialogBody = styled.div` 
    background-color: #fefefe;
    margin: auto auto 150px;
    padding: 25px;
    box-shadow: rgb(192 192 192) 0px 1px 5px 2px;
    width: 500px;
    max-height: 540px;
    min-height: 100px;
    border-radius: 4px;
    overflow-y: auto;
    position: absolute;
    left: calc(40% + 175px);
    transform: translate(-50%, 0);
    overscroll-behavior: none;
    top: 30%;
  
    @media screen and (min-width: ${Breakpoints.sm}) {
      left: 50%;
    }

    ${mediaHelperMaxWidth.md`
      width: 90%;
      left: 50%;
      max-height: calc(100% - 65px)
    `}
`;


export const Content = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;

  span {
    padding: 10px;
  }
`;

export const TextArea = styled.textarea`
  width:100%;
  height: 120px;
  padding:15px;
  border:2px solid ${Colors.GRAY[3]};
  border-radius:8px;
  resize:none;
  font-family: Courier, monospace;
  font-weight: ${FontWeight.SemiBold};
  color: ${Colors.GRAY[6]};
  font-size:14px;
`;